import { NumberField } from '@calendly/ui/form/number-field';
import classNames from 'classnames';
import { forwardRef } from 'react';
const quantityInputCss = "q13x5i36";
export const QuantityInput = forwardRef((props, ref) => <NumberField ref={ref} {...props} className={classNames(quantityInputCss, props.className)} />);
const paragraphCss = "p5faado";
export const Paragraph = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(paragraphCss, props.className)} />;
});
const quantityInputContainerCss = "q17smka";
export const QuantityInputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(quantityInputContainerCss, props.className)} />;
});
const errorMessageCss = "e1ih6qax";
export const ErrorMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorMessageCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");